import { render, staticRenderFns } from "./CabinBookings.vue?vue&type=template&id=0d652fa0&scoped=true&"
import script from "./CabinBookings.vue?vue&type=script&lang=js&"
export * from "./CabinBookings.vue?vue&type=script&lang=js&"
import style0 from "./CabinBookings.vue?vue&type=style&index=0&id=0d652fa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d652fa0",
  null
  
)

export default component.exports